<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="销司名称" prop="salesCompanyCode">
        <el-select v-model="search.salesCompanyCode" placeholder="请选择" clearable style="width: 200px">
          <el-option v-for="item in salesCompanyOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="品类" prop="category">
        <el-select v-model="search.category" placeholder="请选择" clearable style="width: 150px">
          <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计价方式" prop="pricingMode">
        <el-select v-model="search.pricingMode" placeholder="请选择" clearable style="width: 150px">
          <el-option v-for="item in pricingModeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="更新时间">
        <el-date-picker
          clearable
          v-model="createdTime"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeCreatedTime"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <div>
        <el-button type="primary" size="medium" @click="handleAdd()">新增</el-button>
        <el-button type="primary" size="medium" @click="exportExcel()">导出</el-button>
        <el-button type="primary" size="medium" @click="importExcel()">导入</el-button>
      </div>
      <div>
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm">重置</el-button>
      </div>
    </div>
    <el-table ref="checktableData" :data="list" v-loading="listLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="编号" type="index" width="80"></el-table-column>
      <el-table-column label="销司名称" prop="salesCompanyName" min-width="120"></el-table-column>
      <el-table-column label="品牌" prop="brandName" width="100">
        <template slot-scope="scope">{{ scope.row.brandName || ' ' }}</template>
      </el-table-column>
      <el-table-column label="品类" prop="categoryName" width="100">
        <template slot-scope="scope">{{ scope.row.categoryName || scope.row.category }}</template>
      </el-table-column>
      <el-table-column label="铜管" prop="hasCopperPipeName" width="100">
        <template slot-scope="scope">{{ scope.row.hasCopperPipeName || scope.row.hasCopperPipe }}</template>
      </el-table-column>
      <el-table-column label="单双片" prop="panelTypeName" width="100">
        <template slot-scope="scope">{{ scope.row.panelTypeName}}</template>
      </el-table-column>
      <el-table-column label="匹数" prop="horsepower" width="100">
        <template slot-scope="scope">{{ scope.row.horsepower }}</template>
      </el-table-column>
      <el-table-column label="价格" prop="price" width="120">
        <template slot-scope="scope">{{ scope.row.price }} {{ scope.row.pricingMode === 'WEIGHT' ? '元/kg' : '元/套' }}</template>
      </el-table-column>
      <el-table-column label="计价方式" prop="pricingModeName" width="100">
        <template slot-scope="scope">{{ scope.row.pricingModeName || scope.row.pricingMode }}</template>
      </el-table-column>
      <el-table-column label="最后更新" prop="lastModifiedDate" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.lastModifiedDate }}</span>
          <el-popover v-if="scope.row.id" placement="bottom" trigger="hover" popper-class="update-log-popover" @show="handleShowLogs(scope.row)">
            <div class="log-header">更新记录（共{{ logList.length }}条）</div>
            <ul class="log-list" v-loading="logLoading">
              <li v-for="(item, index) in logList" :key="index">
                <div class="log-content">
                  <div class="log-change">{{ item.changeContent }}</div>
                  <div class="log-meta">
                    <span class="log-time">{{ item.operateTime }}</span>
                    <span class="log-user">{{ item.operatorName }}</span>
                  </div>
                </div>
              </li>
            </ul>
            <span slot="reference" class="log-icon">
              <i class="el-icon-info"></i>
            </span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="180" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goEdit(scope.row)">编辑</el-button>
          <el-button type="text" style="color: #F56C6C" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.pageNum"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <editOldValuation ref="editOldValuationRef" @opera-success="getList"></editOldValuation>
    <importOldValuation ref="importOldValuationRef" @opera-success="handleSearch"></importOldValuation>
    <!-- 更新记录弹窗 -->
    <importOldValuation ref="importOldValuationRef" @opera-success="handleSearch"></importOldValuation>
  </div>
</template>
<script>
import editOldValuation from './components/editOld'
import importOldValuation from './components/importOld'

import { getPriceDisplayPage, getSalesCompanies, getPriceDisplayLogs, deletePriceDisplay } from '@/api/oldValuation'
import dayjs from 'dayjs'

export default {
  name: 'oldMachineValue',
  components: {
    editOldValuation,
    importOldValuation
  },
  filters: {},

  data() {
    return {
      list: [],
      total: 0, //列表总条数
      listLoading: false,
      logList: [], // 当前行的更新记录列表
      logLoading: false,
      createdTime: null, //更新时间范围
      search: {
        salesCompanyCode: null, //销司编码
        category: null, //品类
        pricingMode: null, //计价方式
        updateTimeFrom: null, //更新时间起
        updateTimeTo: null, //更新时间止
        pageNum: 1, //当前页
        pageSize: 10
      },
      // 销司枚举（动态获取）
      salesCompanyOptions: [],
      // 品类枚举
      categoryOptions: [
        { label: '空调柜机', value: 'CABINET' },
        { label: '空调挂机', value: 'WALL_MOUNT' }
      ],
      // 计价方式枚举
      pricingModeOptions: [
        { label: '按重量', value: 'WEIGHT' },
        { label: '按套数', value: 'SETS' }
      ]
    }
  },
  mounted() {
    this.getList()
    this.fetchSalesCompanies()
  },
  methods: {
    // 获取销司枚举
    async fetchSalesCompanies() {
      const res = await getSalesCompanies()
      if (res.statusCode == 200 && Array.isArray(res.data)) {
        this.salesCompanyOptions = res.data.map(item => ({
          label: item.name,
          value: item.code
        }))
      }
    },
    handleSearch() {
      this.search.pageNum = 1
      this.getList()
    },
    async getList() {
      let res = await getPriceDisplayPage(this.search)

      if (res.statusCode == 200) {
        this.list = res.data.records || []
        this.total = res.data.total || 0
      }
    },
    resetForm() {
      this.createdTime = null
      this.search = this.$options.data().search
      this.getList()
    },

    handleSizeChange(val) {
      this.search.pageNum = 1
      this.search.pageSize = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    changeCreatedTime(val) {
      if (val && val.length === 2) {
        this.search.updateTimeFrom = val[0] + ' 00:00:00'
        this.search.updateTimeTo = val[1] + ' 23:59:59'
      } else {
        this.search.updateTimeFrom = null
        this.search.updateTimeTo = null
      }
    },
    // Instant对象转日期字符串
    formatInstant(instant) {
      if (!instant || !instant.seconds) return ''
      return dayjs(instant.seconds * 1000).format('YYYY-MM-DD HH:mm:ss')
    },

    async goEdit(rowData) {
      this.$refs.editOldValuationRef.openDialog(rowData)
    },
    handleDelete(row) {
      this.$dialog({
        title: '删除确认',
        content: '确认删除该价格配置？',
        cancel_buttton: '取消',
        ok_buttton: '确定',
        width: '400px',
        footBtn: 'card',
        dialogType: 'sighicon',
        onOk: async () => {
          const res = await deletePriceDisplay(row.id)
          if (res.statusCode == 200) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error(res.message || '删除失败')
          }
        },
        onCancel: () => {}
      })
    },
    handleAdd() {
      this.$refs.editOldValuationRef.openDialog(null, 'add')
    },
    // 导入
    importExcel() {
      this.$refs.importOldValuationRef.openDialog()
    },
    // 鼠标悬停显示更新记录
    async handleShowLogs(row) {
      this.logLoading = true
      this.logList = []
      try {
        const res = await getPriceDisplayLogs(row.id)
        if (res.statusCode == 200 && Array.isArray(res.data)) {
          this.logList = res.data.map(item => ({
            ...item,
            operateTimeStr: this.formatInstant(item.operateTime)
          }))
        }
      } finally {
        this.logLoading = false
      }
    },
    //导出
    exportExcel() {
      let url = `/autoapp-default-server-recovery/api/priceDisplay/export`
      const { salesCompanyCode, category, pricingMode, updateTimeFrom, updateTimeTo } = this.search
      this.HttpService.post(url, { salesCompanyCode, category, pricingMode, updateTimeFrom, updateTimeTo }).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.row-bg {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
}

// 更新记录图标样式
.log-icon {
  margin-left: 8px;
  color: #409eff;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    color: #66b1ff;
  }
}

// Popover 自定义样式（非 scoped，因为 popover 挂载到 body）
/deep/ .update-log-popover {
  padding: 0;
  min-width: 350px;
  max-width: 500px;

  .log-header {
    padding: 12px 16px;
    background-color: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
    font-weight: bold;
    font-size: 14px;
    color: #303133;
  }

  .log-list {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 300px;
    overflow-y: auto;

    li {
      padding: 12px 16px;
      border-bottom: 1px solid #ebeef5;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background-color: #f5f7fa;
      }
    }

    .log-content {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .log-change {
        font-size: 14px;
        color: #303133;
        line-height: 1.6;
        word-break: break-all;
      }

      .log-meta {
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 12px;
        color: #909399;

        .log-time {
          color: #909399;
        }

        .log-user {
          color: #909399;
          &::before {
            content: '·';
            margin-right: 12px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/oldMachineValue.vue